import L from 'leaflet';
import evMarker from '../assets/icons/ev-marker.svg';
import othersMarker from '../assets/icons/others-map-marker.svg';
import { poiFilters } from './constants';

// Create custom icon for EV markers
export const createEvIcon = (size = 32) => {
  return new L.Icon({
    iconUrl: evMarker,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    popupAnchor: [0, -size]
  });
};

// Get POI icon based on category
export const getPoiIcon = (category) => {
  const filter = poiFilters.find(f => f.categoryValue === category);
  const iconUrl = filter ? filter.mapIcon : othersMarker; // Use default icon if no match found

  return new L.Icon({
    iconUrl: iconUrl,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
    popupAnchor: [0, -26]
  });
};

// Create cluster custom icon
export const createClusterCustomIcon = (cluster) => {
  return L.divIcon({
    html: `<div style="
      background: #004E98;
      color: #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      font-family: 'Helvetica Neue', Arial, sans-serif;
      border: 2px solid #fff;
      box-shadow: 0 2px 6px rgba(0,0,0,0.15);
    ">${cluster.getChildCount()}</div>`,
    className: 'custom-marker-cluster',
    iconSize: [40, 40]
  });
};

// Pan to station with offset
export const panToStation = (map, station, bottomSheetHeight = 350) => {
  // console.log('panToStation called with:', station?.station_name, 'map:', !!map);
  if (!map || !station) {
    // console.log('panToStation: map or station is null, returning');
    return;
  }

  const zoom = map.getZoom() < 15 ? 15 : map.getZoom();
  // console.log('panToStation: target zoom:', zoom, 'current zoom:', map.getZoom());

  // The vertical offset is half the sheet height, moving the center up.
  const yOffset = -bottomSheetHeight / 2;
  const xOffset = 0;

  // Get the pixel coordinates of the station at the target zoom level
  const targetPoint = map.project([station.latitude, station.longitude], zoom);
  // Apply the offset
  const newCenterPoint = targetPoint.subtract([xOffset, yOffset]);
  // Convert the new center point back to geographical coordinates
  const newCenterLatLng = map.unproject(newCenterPoint, zoom);

  // console.log('panToStation: flying to:', newCenterLatLng, 'zoom:', zoom);
  // Fly to the new, adjusted center
  map.flyTo(newCenterLatLng, zoom, { duration: 1 });
};

// Prevent browser zoom and handle viewport issues
export const setupZoomPrevention = () => {
  // Prevent zoom on double tap
  let lastTouchEnd = 0;
  const preventZoom = (e) => {
    const now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  };

  // Prevent zoom on wheel
  const preventWheelZoom = (e) => {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
    }
  };

  // Prevent zoom on keyboard
  const preventKeyboardZoom = (e) => {
    if ((e.ctrlKey || e.metaKey) && (e.key === '+' || e.key === '-' || e.key === '=')) {
      e.preventDefault();
    }
  };

  // Force viewport scale to 1
  const forceViewportScale = () => {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover');
    }
  };

  // Apply event listeners
  document.addEventListener('touchend', preventZoom, { passive: false });
  document.addEventListener('wheel', preventWheelZoom, { passive: false });
  document.addEventListener('keydown', preventKeyboardZoom, { passive: false });

  // Force viewport scale on load and resize
  forceViewportScale();
  window.addEventListener('resize', forceViewportScale);
  window.addEventListener('orientationchange', forceViewportScale);

  // Return cleanup function
  return () => {
    document.removeEventListener('touchend', preventZoom);
    document.removeEventListener('wheel', preventWheelZoom);
    document.removeEventListener('keydown', preventKeyboardZoom);
    window.removeEventListener('resize', forceViewportScale);
    window.removeEventListener('orientationchange', forceViewportScale);
  };
}; 